import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {SidebarNode} from './nav.interfaces';

@Component({
    selector: 'app-nav-node',
    templateUrl: './nav-node.component.html',
    styleUrls: ['./nav-node.component.css']
})
export class NavNodeComponent {

    @Input() node: SidebarNode;
    @Input() nodeClass: any;

    constructor(private router: Router) {
    }

    isActive(url) {
        if (typeof url !== 'string') {
            const urlTree = this.router.createUrlTree(url);
            return this.router.url === this.router.serializeUrl(urlTree);
        } else {
            return this.router.isActive(url, true);
        }
    }

    isDisabled() {
        const disabled = this.node.disabled;
        if (typeof disabled === 'function') {
            return disabled();
        } else {
            return disabled;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_shared/nav/nav-node.component.ts